// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"advantages_wrapper__2M9QI","main":"advantages_main__i4zy2"};